module.exports = __webpack_public_path__ + "static/media/inactive-random.102fff1f.svg";